import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import "./button.css";
import ArrowRight from "../../../assets/icons/arrow-right.png";

function Button({
  title = "",
  icon = ArrowRight,
  onClick = () => {},
  className = "",
  variant = "primary",
  type = "primary",
  textSpacing = "!px-[18px] lg:px-[24px]",
  noAnimation = false,
  htmlType = "button",
  ...rest
}) {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={htmlType}
      className={clsx(`btn btn-${type}`, noAnimation && `bg-${variant}`, className)}
      onClick={onClick}
      style={{ borderColor: `var(--color-${variant})` }}
      {...rest}
    >
      <span
        className={clsx(noAnimation && "!transition-none", textSpacing)}
        style={{
          backgroundImage: `linear-gradient(var(--color-${variant}), var(--color-${variant}))`,
        }}
      >
        {title}
      </span>
      {icon && (
        <span
          className={clsx(noAnimation && "!transition-none")}
          style={{
            backgroundImage: `linear-gradient(var(--color-${variant}), var(--color-${variant}))`,
          }}
        >
          <img className="inline-block" src={icon} alt="arrow icon" />
        </span>
      )}
    </button>
  );
}

export default Button;

Button.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool, PropTypes.node]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(["primary", "secondary"]),
  variant: PropTypes.oneOf([
    "primary",
    "warning",
    "purple",
    "success",
    "danger",
    "info",
    "warning-800",
  ]),
  textSpacing: PropTypes.string,
  noAnimation: PropTypes.bool,
  htmlType: PropTypes.oneOf(["button", "submit", "reset"]),
};
